import { AccountAggregate } from './account';
import Analytics from '@withlocals/withlocals-analytics';
import { AuthenticationInfo } from '../model/AuthenticationInfo';

export interface Context {
  unsubscribe: () => void;
  accountAggregate: AccountAggregate;
}

export const buildContext = (authInfo: AuthenticationInfo): Context => {
  const accountAggregate = new AccountAggregate(authInfo);

  accountAggregate.queries.account$.subscribe((accountState) => {
    if (accountState.account) {
      Analytics.identify(accountState.account);
    }
  });

  const unsubscribe = () => {
    try {
      accountAggregate.dispose();
    } catch (e) {
      console.error(e);
    }
  };

  return {
    unsubscribe,
    accountAggregate,
  };
};
